import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  isAssetsLayoutChanged: false,
};

const balanceSheetSlice = createSlice({
  name: "balanceSheet",
  initialState,
  reducers: {
    setIsAssetsLayoutChanged(state, action: PayloadAction<boolean>) {
      state.isAssetsLayoutChanged = action.payload;
    },
  },
});

export const balanceSheetActions = balanceSheetSlice.actions;
export default balanceSheetSlice;
